import React from 'react';
import favImg from '../images/fav.png';
import nofavImg from '../images/nofav.png';
import './ProjectFavorite.css';

class ProjectFavorite extends React.Component {
    favorite() {
        const fav = !this.props.isFavorite
        this.setState({ fav }, _ => {
            if (fav) {
                localStorage.setItem(this.props.id, JSON.stringify(this.props));
            } else {
                localStorage.removeItem(this.props.id)
            }
            this.props.favoriteClick();
        })
    }
    render() {
        return (
            <div className="project-star-fav" onClick={_ => this.favorite()}>
                <img alt="favoriteLogo" style={{ width: "30px" }} src={this.props.isFavorite ? favImg : nofavImg} />
            </div>
        )
    }
}

export default ProjectFavorite;